import React from "react";
import styled from "styled-components";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";

const FabWrapper = styled.div`
  position: fixed;
  bottom: 2rem;
  right: 3rem;

  z-index: 100000000;

  @media (max-width: 1124px) {
    right: 1rem;
    bottom: calc(56px + 1rem);
  }
`;

const FloatingActionButton = props => {
  return (
    <FabWrapper>
      {props.tooltip === undefined ? (
        <Fab color="primary" onClick={props.onClick}>
          {props.icon ? <props.icon /> : <AddIcon />}
        </Fab>
      ) : (
        <Tooltip title={props.tooltip} placement="top">
          <Fab color="primary" onClick={props.onClick}>
            {props.icon ? <props.icon /> : <AddIcon />}
          </Fab>
        </Tooltip>
      )}
    </FabWrapper>
  );
};

export default FloatingActionButton;
